import { LayoutView } from '../../components/Layout/Layout'


export const LegacyPage = () => {

  return (
    <main>
      <LayoutView
        mainContent={<iframe src={window.location.href} className="w-full h-full" frameBorder="0" title="Legacy page" />}
      />
    </main>
  )
}